"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@ux/button"));
var _ToolTipWrapper = require("./ToolTipWrapper");
var _utils = require("@site/utils");
var _EidCodes = _interopRequireDefault(require("./constants/EidCodes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LLCMessage = ({
  llcMessageOptions,
  domainName
}) => {
  const {
    llcMessageText,
    llcMessageLink,
    showLLCMessageLogo,
    geoRegionStateCode,
    llcMessageLogoSrc,
    llcMessageTooltipContent = []
  } = llcMessageOptions;
  const handleLinkClick = () => {
    (0, _utils.logEvent)({
      eid: _EidCodes.default.llcMessageAffiliateClick,
      type: 'click',
      properties: {
        domainName
      }
    });
  };
  (0, _react.useEffect)(() => {
    (0, _utils.logImpression)(_EidCodes.default.llcMessageImpression);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", {
    className: "w-100"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center mt-2"
  }, showLLCMessageLogo && /*#__PURE__*/_react.default.createElement("img", {
    "data-testid": "llc-message-logo",
    src: llcMessageLogoSrc,
    alt: "LLC Registration Partner Logo",
    className: "mr-3",
    width: 82,
    height: 24
  }), /*#__PURE__*/_react.default.createElement("div", null, llcMessageText && /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: llcMessageText,
    values: {
      domainName,
      geoRegionStateCode
    }
  }), llcMessageLink?.url && /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-testid": "llc-message-link",
    design: "inline",
    className: "text-black ml-1",
    href: llcMessageLink?.url,
    text: /*#__PURE__*/_react.default.createElement("span", {
      className: 'ms-1'
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: llcMessageLink?.textId
    })),
    onClick: handleLinkClick,
    external: true
  }), /*#__PURE__*/_react.default.createElement(_ToolTipWrapper.TooltipWrapper, {
    dataCy: "llc-message-tooltip",
    tooltipContent: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "llcMessage.tooltipContent"
    }), /*#__PURE__*/_react.default.createElement("ul", {
      className: "pl-4"
    }, llcMessageTooltipContent.map(item => /*#__PURE__*/_react.default.createElement("li", {
      key: item
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: `llcMessage.tooltipContent.${item}`
    }))))),
    id: "llc-message-tooltip",
    dataEid: _EidCodes.default.llcMessageTooltipClick
  }))));
};
LLCMessage.propTypes = {
  llcMessageOptions: _propTypes.default.shape({
    llcMessageText: _propTypes.default.string,
    llcMessageLink: _propTypes.default.shape({
      url: _propTypes.default.string,
      textId: _propTypes.default.string
    }),
    showLLCMessageLogo: _propTypes.default.bool,
    geoRegionStateCode: _propTypes.default.string,
    llcMessageLogoSrc: _propTypes.default.string,
    showLLCEmailMessage: _propTypes.default.bool,
    llcMessageTooltipContent: _propTypes.default.array
  }),
  domainName: _propTypes.default.string,
  state: _propTypes.default.string
};
var _default = exports.default = LLCMessage;